import React, { useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductsByCategory } from "../../Redux/slice/productSlice";
import { Card, Button, Tag } from "antd";
import { ShoppingCartOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const Aircondition = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { productsByCategory = {}, loading: productsLoading } = useSelector((state) => state.products);
  const GTM_ID = "GTM-WKCL4JTV"; // Your GTM ID
  const hardcodedCategoryId = "db54033b-e95d-4a6c-8744-45e4d462c19e"
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchProductsByCategory(hardcodedCategoryId));
  }, [dispatch]);

  const filteredProducts = useMemo(() => {
    return (productsByCategory[hardcodedCategoryId] || [])
      .slice()
      .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));
  }, [productsByCategory]);

  const formatPrice = (amount) =>
    amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // Google Tag Manager
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(script);
  }, []);

  // Google AdSense
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
    script.setAttribute("data-ad-client", "YOUR_ADSENSE_CLIENT_ID"); // Add the actual AdSense Client ID
    document.head.appendChild(script);
  }, []);
  

  if ( productsLoading) {
    return (
      <div className="max-w-6xl mx-auto p-4 mt-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="animate-pulse border rounded-lg shadow-lg p-3 bg-gray-100">
              <div className="h-40 bg-gray-300 rounded-md"></div>
              <div className="mt-2 h-4 bg-gray-300 rounded w-3/4"></div>
              <div className="mt-1 h-4 bg-gray-300 rounded w-1/2"></div>
              <div className="mt-3 h-8 bg-gray-300 rounded w-10 self-end"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto py-6 px-4">
     <noscript>
  <iframe
    src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
    height="0"
    width="0"
    style={{ display: "none", visibility: "hidden" }}
    title="Google Tag Manager"
  ></iframe>
</noscript>

      {/* SEO Metadata */}
    
      <Helmet>
  <title>Buy Air Conditioners Online - Best Prices in Ghana</title>
  <meta name="description" content="Explore the best air conditioners in Ghana. Find top brands at affordable prices and enjoy fast delivery." />
  <meta name="keywords" content="Air Conditioners, Buy AC Online, Best AC Brands in Ghana, Affordable Air Conditioners" />

  {/* Open Graph Meta Tags for Social Media */}
  <meta property="og:title" content="Buy Air Conditioners Online - Best Prices in Ghana" />
  <meta property="og:description" content="Find top air conditioner brands at unbeatable prices. Shop now for fast delivery in Ghana." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content= "https://www.frankotrading.com/air-condition" />
  <meta property="og:image" content={filteredProducts.length > 0 ? `https://smfteapi.salesmate.app/Media/Products_Images/${filteredProducts[0].productImage.split("\\").pop()}` : "default-image-url"} />

  {/* Twitter Card for better previews on Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Buy Air Conditioners Online - Best Prices in Ghana" />
  <meta name="twitter:description" content="Shop the best air conditioners at unbeatable prices with fast delivery in Ghana." />
  <meta name="twitter:image" content={filteredProducts.length > 0 ? `https://smfteapi.salesmate.app/Media/Products_Images/${filteredProducts[0].productImage.split("\\").pop()}` : "default-image-url"} />
 {/* Canonical URL */}
 <link rel="canonical" href="https://www.frankotrading.com/air-condition" />
  {/* JSON-LD Structured Data for Schema.org */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "Air Conditioners",
      "description": "Shop high-quality air conditioners from top brands.",
      "url": "https://www.frankotrading.com/air-condition",
      "itemListElement": filteredProducts.map((item, index) => ({
        "@type": "Product",
        "position": index + 1,
        "name": item.productName,
        "description": item.description,
        "sku": item.productID,
        "image": `https://smfteapi.salesmate.app/Media/Products_Images/${item.productImage.split("\\").pop()}`,
        "brand": {
          "@type": "Brand",
          "name": item.brandName
        },
        "offers": {
          "@type": "Offer",
          "priceCurrency": "GHS",
          "price": item.price,
          "priceValidUntil": "2025-12-31",
          "itemCondition": "https://schema.org/NewCondition",
         "availability": "https://schema.org/InStock",
          "url": `https://www.frankotrading.com/product/${item.productID}`,
          "seller": {
            "@type": "Organization",
            "name": "Franko Trading"
          },
          "shippingDetails": {
            "@type": "OfferShippingDetails",
            "shippingRate": {
              "@type": "MonetaryAmount",
              "currency": "GHS",
              "value": "30.00"
            },
            "shippingDestination": {
              "@type": "DefinedRegion",
              "addressCountry": "GH"
            },
            "deliveryTime": {
              "@type": "ShippingDeliveryTime",
              "handlingTime": {
                "@type": "QuantitativeValue",
                "minValue": 1,
                "maxValue": 2,
                "unitCode": "DAY"
              },
              "transitTime": {
                "@type": "QuantitativeValue",
                "minValue": 3,
                "maxValue": 5,
                "unitCode": "DAY"
              }
            }
          },
          "hasMerchantReturnPolicy": {
            "@type": "MerchantReturnPolicy",
            "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
            "merchantReturnDays": 14,
            "returnMethod": "https://schema.org/ReturnByMail",
            "returnFees": "https://schema.org/FreeReturn", 
            "applicableCountry": "GH"
          },
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.5",
          "reviewCount": "120"
        },
        "review": {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "John Doe"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          }
        }

      }))
    })}
  </script>
</Helmet>
<script>
        {`
          (function(w,d,s,l,i){
            w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-WKCL4JTV');
        `}
      </script>


      {/* Section Title */}
      <div className="flex flex-col items-center text-center my-6">
  <span className="text-sm font-semibold text-red-500 tracking-wide">BEST & QUALITY</span>
  <div className="relative w-full flex items-center justify-center">
    <hr className="w-1/4 border-gray-300 hidden md:block" />
    <h2 className="text-xl md:text-2xl font-bold text-gray-800 mx-4">
   AIR-CONDITONERS
    </h2>
    <hr className="w-1/4 border-gray-300 hidden md:block" />
  </div>
</div>
      {/* Products Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-4">
        {filteredProducts.map((item) => (
          <Card
            key={item.productID}
            hoverable
            className="rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-xl group relative"
            cover={
              <div
                onClick={() => navigate(`/product/${item.productID}`)}
                className="cursor-pointer relative h-full flex items-center justify-center"
              >
                <img
                  src={`https://smfteapi.salesmate.app/Media/Products_Images/${item.productImage.split("\\").pop()}`}
                  alt={item.productName}
                  className="w-full h-full object-cover rounded-t-lg"
                />
              </div>
            }
          >
            <div className="flex flex-col">
              <p className="font-semibold text-sm line-clamp-2">{item.productName}</p>
              <p className="text-red-500 font-bold text-sm">₵{formatPrice(item.price)}</p>
            </div>
            <Tag color="green">{item.brandName}</Tag>
            <Button
              shape="circle"
              icon={<ShoppingCartOutlined />}
              className="absolute bottom-4 right-4 bg-red-500 text-white opacity-0 group-hover:opacity-100 transition-opacity"
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
          </Card>
        ))}
      </div>
    </div>
  );
};

export default Aircondition;
